import { Component, inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { ModalContentComponent, RxButtonModule } from '@roomex/rx-components';
import { translationProvider as TranslationsProvider, TRANSLATION_SCOPE } from './assets/i18n/translation.provider';


@Component({
  selector: 'rx-applications-delete-confirmation-modal',
  standalone: true,  
  imports: [TranslocoModule, ModalContentComponent, RxButtonModule],
  templateUrl: './delete-out-of-office-period-modal.component.html',
  styleUrl: './delete-out-of-office-period-modal.component.scss',
  providers: [TranslationsProvider],
})
export class DeleteOutOfOfficePeriodModalComponent {
  public readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  activeModal = inject(NgbActiveModal);

  confirmDeletion() {
    this.activeModal.close();
  }
}
